module.exports = __webpack_public_path__ + "img/fb-simple-produit.f27849c5.svg";